<template>
  <div class="kye-textarea">
    <kye-input type="textarea"
               ref="input"
               class="kye-textarea-txt"
               :disabled="isDisabled"
               v-bind="inputAttr"
               v-on="$listeners"
               v-model="currentValue"
               @keydown.native="onKeydown"
               @input="onInput"></kye-input>
    <div class="kye-textarea-tips" :class="{err: count < 0}" v-if="!isDisabled">
      <div><span class="count">{{ maxLength - count }}</span> / {{ maxLength }}</div>
    </div>
  </div>
</template>

<script>
  const defaultSize = 300
  export default {
    name: 'KyeTextarea',
    inject: {
      elForm: {
        default: ''
      }
    },
    props: {
      maxLength: {
        type: Number,
        default: defaultSize
      },
      showErrorTips: {
        type: Boolean,
        default: true
      },
      value: {
        type: String,
        default: ''
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      inputAttr () {
        const obj = {
          ...this.$attrs,
        }
        if (!this.showErrorTips) {
          obj.maxlength = this.maxLength
        }
        return obj
      },
      isDisabled () {
        return this.disabled || (this.elForm || {}).disabled
      }
    },
    data () {
      return {
        currentValue: this.value,
        count: defaultSize
      }
    },
    watch: {
      maxLength (val, oldVal) {
        if (val !== oldVal) {
          this.count = this.count + val - oldVal
        }
      },
      value (val, oldVal) {
        if (val !== oldVal) {
          this.onInput(val)
        }
      }
    },
    mounted () {
      this.onInput(this.value)
    },
    methods: {
      onInput (val) {
        // 默认值会出现 null undefined 的情况
        const len = typeof val === 'string' ? val.length : 0
        this.count = this.maxLength - len
        this.currentValue = val
        this.$emit('input', val)
      },
      onKeydown (e) {
        this.$emit('keydown', e)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/public/components/kye-textarea/index.vue